<div class="user-info-wrapper" [style.right]="rightPosition">
  <div class="user-info-header"></div>
  <img class="user-info-img" src="../../../../../assets/icons/default-avatar.svg" />
  <div class="user-info-name">{{user.username}}</div>
  <div class="user-info-details">{{user.details}}</div>
  <button class="btn-logout" (click)="onLogoutButtonClicked()" title="Log out">Log out</button>
</div>
